<template>

    <div id="home">

        <HomeHero />

        <HomeContentSection />

        <HomePackages />

        <HomeStats />

        <HomeShowroom />

        <HomeTestimonials v-if="displayTestimonials" />
        
        <TrustedCompanies v-if="displayTrustedCompanies"/>

        <HomeCta />

        <HomeFaq />

        <CookieNotice />

    </div>

</template>

<script>
/* eslint-disable */

import HomeHero from './Home/Hero.vue';
import HomeContentSection from './Home/ContentSection.vue';
import HomePackages from './Home/Packages.vue';
import HomeStats from './Home/Stats.vue';
import HomeShowroom from './Home/Showroom.vue';
import HomeTestimonials from './Home/Testimonials.vue';
import TrustedCompanies from './Home/TrustedCompanies.vue';
import HomeCta from './Home/Cta.vue';
import HomeFaq from './Home/Faq.vue';
import CookieNotice from '../components/cookie-notice.vue';


export default {
    name: 'Home',

    props: {
        displayTestimonials: {
            type: Boolean,
            default: false
        },
        displayTrustedCompanies: {
            type: Boolean,
            default: false
        }
    },

    components: {
        HomeHero,
        HomeContentSection,
        HomePackages,
        HomeStats,
        HomeShowroom,
        HomeTestimonials,
        TrustedCompanies,
        HomeCta,
        HomeFaq,
        CookieNotice
    },

    mounted() {
        document.title = 'DANTRIX PRO | ' + this.$options.filters.toTitleCase(
            this.$options.filters.i('home')
        );

        if (
            window.mainUI &&
            typeof window.mainUI === 'function'
        ) {
            setTimeout(
                window.mainUI,
                150
            );
        }
    }
};
</script>